<template>
  <section>
    <div class="over-contents__playtool play-control" id="playtoolblock">
      <div class="over-contents__playtool--header">
        <label>{{ baseYYYYMMDD }} {{ startTime }}</label>
        <label class="play-control-header-separate">-</label>
        <label>{{ endTime }}</label>
      </div>
      <div class="over-contents__playtool--tool" id="playtool">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="1">
            <label>{{ currentTime }}</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
            <input
              class="slider"
              type="range"
              :value="current"
              :min="start"
              :max="end"
              @mousedown="event => onSliderDown(event.target.value)"
              @mouseup="event => onSliderUp(event.target.value)"
            />
          </vs-col>
        </vs-row>
      </div>
      <vs-row>
        <vs-col class="over-contents__playtool--btn" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vx-tooltip
            text="前の10分"
            :color="AISEA_COLOR.BLACK"
          >
            <button
              @click="onClickPrev"
              :disabled="isDisablePrev"
            >
              <feather-icon icon="SkipBackIcon" svgClasses="w-3 h-3"/>
            </button>
          </vx-tooltip>
          <button v-if="is_pause" @click="() => onPlay()" :class="play">
            <feather-icon icon="PlayIcon" svgClasses="w-3 h-3"/>
          </button>
          <button v-else @click="() => onPause()">
            <feather-icon icon="PauseIcon" svgClasses="w-3 h-3"/>
          </button>
          <button @click="() => setFPS(1)" :class="fps === 1 ? 'active' : ''">x1</button>
          <button @click="() => setFPS(2)" :class="fps === 2 ? 'active' : ''">x2</button>
          <button @click="() => setFPS(4)" :class="fps === 4 ? 'active' : ''">x4</button>
          <button @click="() => setFPS(8)" :class="fps === 8 ? 'active' : ''">x8</button>
          <button @click="() => setFPS(16)" :class="fps === 16 ? 'active' : ''">x16</button>
          <button @click="() => setFPS(32)" :class="fps === 32 ? 'active' : ''">x32</button>
          <vx-tooltip
            text="次の10分"
            :color="AISEA_COLOR.BLACK"
          >
            <button
              @click="onClickNext"
              :disabled="isDisableNext"
            >
              <feather-icon icon="SkipForwardIcon" svgClasses="w-3 h-3"/>
            </button>
          </vx-tooltip>
        </vs-col>
      </vs-row>
    </div>
  </section>
</template>

<script>
  import moment from "moment-timezone";
  import {ColorMixin} from "@/mixins";

  export default {
    name: "VesselVoyageHistoryPlayerControl",
    mixins: [ColorMixin],
    data() {
      return {
        sliderColor: "#4A90E2",
      };
    },
    props: {
      current: {type: Number, required: true},
      start: {type: Number, required: true},
      end: {type: Number, required: true},
      fps: {type: Number, required: true},
      is_pause: {type: Boolean, required: true}
    },
    computed: {
      reverse: function () {
        return {
          active: this.getReverse && !this.getPause
        };
      },
      play: function () {
        return {
          active: !this.getReverse && !this.getPause
        };
      },
      baseYYYYMMDD() {
        return moment.unix(this.start).format("YYYY年MM月DD日")
      },
      startTime() {
        return moment.unix(this.start).format("HH:mm:ss")
      },
      currentTime() {
        return moment.unix(this.current).format("HH:mm:ss")
      },
      endTime() {
        return moment.unix(this.end).format("HH:mm:ss")
      },
      isDisablePrev() {
        return this.startTime === "00:00:00";
      },
      isDisableNext() {
        return this.endTime === "00:00:00";
      }

    },
    watch: {},
    methods: {
      setFPS(fps) {
        this.$emit("setFPS", fps);
      },
      onPlay() {
        this.$emit("onPlay");
      },
      onPause() {
        this.$emit("onPause");
      },
      onSliderDown(time) {
        this.$emit("onSliderDown", time);
      },
      onSliderUp(time) {
        this.$emit("onSliderUp", time);
      },
      onClickPrev() {
        this.$emit("onClickPrev");
      },
      onClickNext() {
        this.$emit("onClickNext");
      },
    },
    beforeDestroy() {
      document.querySelectorAll('body > div.vs-tooltip').forEach(el => {
        if(document.body.contains(el)) {
          document.body.removeChild(el);
        }
      });
    },
  };
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

  .vs-slider--circle-text {
    display: none !important;
  }

  .con-vs-slider {
    margin: 0 auto;
  }

  .over-contents__playtool {
    background-color: #fff;
    width: 420px;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;

    &--header {
      background-color: #9198A1;
      padding: 10px;
      color: #fff;
      text-align: center;
      position: relative;
    }

    &--tool {
      padding: 10px;
    }

    &--btn {
      margin-bottom: 10px;

      button {
        background-color: $aisea-light-gray;
        border: none;
        padding: 8px 12px;

        &:hover:not(:disabled) {
          background-color: $aisea-mouse-gray;
        }

        &:active:not(:disabled) {
          opacity: 0.6;
        }

        &:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
      }

      button.active {
        background-color: #4A90E2;
        color: #fff;
      }
    }

    .over-contents__playtool--btn {
      div:first-child {
        margin-right: 8px;
      }
      div:last-child {
        margin-left: 8px;
      }
    }
  }

  .play-control {
    z-index: 100;

    &-header {
      &-separate {
        margin-left: 10px;
        margin-right: 10px;
      }
    }
  }

  .slider[type=range] {
    -webkit-appearance: none;
    appearance: none;
    background-color: #eee;
    height: 5px;
    width: 90%;
    border-radius: 6px;

    &:focus,
    &:active {
      outline: none;
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      cursor: pointer;
      position: relative;
      border: 2px solid rgba(74, 144, 226, .7);
      width: 22px;
      height: 22px;
      display: block;
      background-color: #fff;
      border-radius: 50%;
      -webkit-border-radius: 50%;
    }

    &:active::-webkit-slider-thumb {
      box-shadow: 0 0 0 4px rgba(74, 144, 226, .6);
      transition: .4s;
    }
  }

#playtoolblock {
  border-radius: 6px;

  .over-contents__playtool--header {
    border-radius: 6px 6px 0 0;
  }
}
</style>
